<template>
  <NuxtLayout>
    <main :class="$style.wrap">
      <div cross-axis-alignment="center" expand :class="$style.content">
        <div :class="$style.statusWrap">
          <i>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="90"
              height="90"
              fill="currentColor"
              viewBox="0 0 48 48"
            >
              <path
                d="M22 30h4v4h-4zm0-16h4v12h-4zm1.99-10C12.94 4 4 12.95 4 24s8.94 20 19.99 20S44 35.05 44 24 35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16z"
              />
            </svg>
          </i>
          <div :class="$style.status">{{ error?.statusCode }}</div>
        </div>

        <header>
          <BaseHeading v-if="error?.statusCode === 404">
            {{
              localizedStrings['pageNotFound'] || 'This page could not be found'
            }}
          </BaseHeading>
          <BaseHeading v-else>
            {{ localizedStrings['anErrorOccurred'] || 'An error occurred' }}
          </BaseHeading>
        </header>

        <BaseButton @click="handleError">
          {{ localizedStrings['backToHomePage'] || 'Back to Home page' }}
        </BaseButton>
      </div>
    </main>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const { localizedStrings } = useLocalizedStrings()

defineProps<{
  error: NuxtError
}>()

const handleError = () => clearError({ redirect: '/' })
</script>

<style lang="scss" module>
.wrap {
  display: grid;
  place-content: center;
  min-height: 66vh;
}

.statusWrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status {
  font-size: 81px;
  font-weight: bold;
}

.content {
  color: var(--error-content-color, #444);
  text-align: center;

  header {
    margin: 1rem auto 2rem;
    text-align: center;

    h1 {
      font-weight: 100;
      font-size: 1.75rem;
    }
  }
}
</style>
